import styled from 'styled-components';
import { Card } from '../card';
import { getColorShade, getColor, getElevation } from '../../../src/styled/utils';
export const StyledDragCard = styled(Card) `
  background-color: ${({ dragging }) => dragging ? getColorShade('primary', 'pressed') : getColor('surface')};
  box-shadow: ${({ dragging }) => (dragging ? getElevation(8) : getElevation(1))};
  user-select: none;

  &:hover {
    background-color: ${({ disabled }) => !disabled && getColorShade('primary', 'hover')};
    cursor: ${({ disabled }) => (disabled ? 'no-drop' : `move`)};
  }

  &:active {
    background-color: ${({ disabled }) => !disabled && getColorShade('primary', 'pressed')};
  }

  &:focus {
    background-color: ${({ disabled }) => !disabled && getColorShade('primary', 'focused')};
  }
`;
